import { Box2, Box3, Vector2, Vector3 } from 'three';

import { isBox3, isVector2Like, isVector3Like } from './typecheck/index.js';

export interface GetCenterFunction {
  (points: Vector2[], target?: Vector2): Vector2;
  (points: Vector3[], target?: Vector3): Vector3;
  (box: Box2, target?: Vector2): Vector2;
  (box: Box3, target?: Vector3): Vector3;
}

const _box2 = new Box2();
const _box3 = new Box3();

/**
 * Returns the center of the bounding box of the given points.
 */
export const getCenter: GetCenterFunction = (mixed: any, target?: any): any => {
  let box: Box2 | Box3 = mixed;

  if (Array.isArray(mixed)) {
    if (isVector3Like(mixed[0])) {
      box = mixed.reduce(
        (acc: Box3, point: Vector3) => acc.expandByPoint(point),
        _box3.makeEmpty()
      );
    } else if (isVector2Like(mixed[0])) {
      box = mixed.reduce(
        (acc: Box2, point: Vector2) => acc.expandByPoint(point),
        _box2.makeEmpty()
      );
    }
  }

  return box.getCenter(target ?? (isBox3(box) ? new Vector3() : new Vector2()));
};
